<template>
  <div class="reset-password-page" :style="{ 'margin-top': resetSuccess ? '100px' : '0' }">
    <!-- 头部图片 -->
    <div class="header-image">
      <img src="@/assets/images/page/header.jpg" alt="页面头部" class="full-width" />

      <img src="@/assets/images/logo.png" class="header-logo" />
      <h1 class="header-title">重置密码</h1>
    </div>
    
    <div class="content-container">
      <div class="reset-form-card">
        <div v-if="resetSuccess" class="success-container bg-white text-center">
          <i class="el-icon-success success-icon"></i>
          <h2 class="success-title">设置成功</h2>
          <div>
            <el-button 
              type="primary" 
              @click="goToHome" 
              class="home-btn"
            >
              返回首页
            </el-button>
          </div>
        </div>

        <el-form 
          v-else
          :model="resetForm" 
          :rules="resetRules" 
          ref="resetForm" 
          label-position="top" 
          label-width="100px"
          class="reset-password-form"
        >
          <!-- 手机号 -->
          <el-form-item label="手机号" prop="phone">
            <el-input 
              v-model="resetForm.phone" 
              placeholder="请输入手机号" 
              maxlength="11"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="图形验证码" prop="captcha" class="captcha-item">
            <el-input v-model="resetForm.captcha" placeholder="请输入图形验证码">
              <template #append>
                <div class="captcha-container">
                  <img 
                    :src="captchaurl" 
                    alt="图形验证码" 
                    @click="getCaptchaImage"
                    style="cursor: pointer; height: 100%; max-width: 90px; object-fit: contain;"
                  >
                </div>
              </template>
            </el-input>
          </el-form-item>
          
          <el-form-item label="短信验证码" prop="smsCode">
            <el-input v-model="resetForm.smsCode" placeholder="请输入短信验证码">
              <template #append>
                <el-button @click="sendSmsCode" :disabled="smsCodeDisabled" size="small">
                  {{ smsCodeText }}
                </el-button>
              </template>
            </el-input>
          </el-form-item>
          
          <el-form-item label="新密码" prop="password">
            <el-input 
              v-model="resetForm.password" 
              placeholder="请输入新密码" 
              type="password" 
              show-password
            ></el-input>
          </el-form-item>

          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input 
              v-model="resetForm.confirmPassword" 
              placeholder="请确认新密码" 
              type="password" 
              show-password
            ></el-input>
          </el-form-item>
          
          <el-button 
            type="primary" 
            @click="submitForm('resetForm')" 
            class="submit-btn"
          >
            确认
          </el-button>

        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { 
  captchaImage,
  postRestPwdOtp,
  resetPwd
} from "@/api/auth";

export default {
  components: {},
  data() {
    return {
      resetForm: {
        phone: '',
        captcha: '',
        smsCode: '',
        password: '',
        confirmPassword: ''
      },
      resetRules: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        captcha: [{ required: true, message: '请输入图形验证码', trigger: 'blur' }],
        smsCode: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { min: 6, message: '确认密码长度不能小于6位', trigger: 'blur' },
          // 使用箭头函数确保 this 指向组件实例
          { validator: (rule, value, callback) => {
            if (value !== this.resetForm.password) {
              callback(new Error('两次输入密码不一致'));
            } else {
              callback();
            }
          }, trigger: 'blur' }
        ]
      },
      captchaurl: '',
      captchaid: '',
      smsCodeDisabled: false,
      smsCodeText: '获取短信验证码',
      smsCodeCountdown: 60,
      otp:'',
      resetSuccess: false,
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getCaptchaImage();
  },
  methods: {
    getCaptchaImage() {
      captchaImage().then((result) => {
        if (result.code === 201) {
          const res = result.data;
          this.captchaurl = res.captcha;
          this.captchaid = res.captchaid;
        }
      });
    },
    async sendSmsCode() {
      //判断账号是否是手机号
      if (!/^1[3-9]\d{9}$/.test(this.resetForm.phone)) {
        this.$message.error('请输入正确的手机号');
        return;
      }
  
      try {
        const res = await postRestPwdOtp(this.resetForm.phone, this.captchaid, this.resetForm.captcha);
        if (res.code === 201) {
          this.$message.success('短信验证码发送成功');
          this.startSmsCountdown();
          this.otp = res.otp;
        } else {
          this.$message.error(res.err || '发送短信验证码失败，请重试');
        }
      } catch (error) {
        this.$message.error('发送短信验证码失败，请重试');
      }
    },
    startSmsCountdown() {
      this.smsCodeDisabled = true;
      this.smsCodeText = `${this.smsCodeCountdown}s 后重试`;
      const timer = setInterval(() => {
        this.smsCodeCountdown--;
        this.smsCodeText = `${this.smsCodeCountdown}s 后重试`;
        if (this.smsCodeCountdown <= 0) {
          clearInterval(timer);
          this.smsCodeDisabled = false;
          this.smsCodeText = '获取短信验证码';
          this.smsCodeCountdown = 60;
        }
      }, 1000);
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          resetPwd(this.resetForm.phone, this.resetForm.smsCode, this.resetForm.password).then((res) => {
            if (res.code === 201) {
              this.$message({ message: '设置成功', type: 'success' });
              this.resetSuccess = true;
            } else {
              this.$message({
                message: res.err || '更新失败',
                type: 'error'
              });
            }
          });

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    goToHome() {
      this.$router.push('/');  // 假设首页路由是'/'
    }
  },
};
</script>

<style>
.el-badge__content.is-dot {
  height: 8px!important;
}
</style>

<style scoped>
.reset-password-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.header-image {
  width: 50%;
  margin: 0 auto; /* 水平居中 */
  position: relative; /* 添加相对定位作为子元素定位容器 */
}

.header-image .header-logo {
  position: absolute;
  top: 10px;
  left: 25px;
  width: 102px;
}

/* 添加标题居中样式 */
.header-image .header-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  color: white;
  font-weight: 600;
  font-size: 24px;
  line-height: 34px;
}

.full-width {
  width: 100%;
  height: auto;
}

.content-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  /* padding: 30px 0; */
}

.reset-form-card {
  /* 修改宽度为50%并居中，与头部图片宽度一致 */
  width: 50%;
  margin: 0 auto; 
  /* 添加白色背景 */
  background-color: #fff;
  /* padding: 0 20px; */
}

/* 添加移动端适配 */
@media (max-width: 768px) {
  .reset-form-card {
    width: 100%;
    padding: 0 15px; /* 增加内边距避免内容贴边 */
  }
  /* 新增：移动端头部图片宽度100% */
  .header-image {
    width: 100%;
    margin: 0;
  }
}

.form-title {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
  font-size: 24px;
}

.reset-password-form {
  background-color: #fff;
  padding: 70px 30px 30px 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.captcha-group, .sms-code-group {
  display: flex;
  gap: 10px;
}

.captcha-input {
  flex: 1;
}

.captcha-image {
  width: 120px;
  height: 40px;
  cursor: pointer;
}

.captcha-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.sms-code-btn {
  width: 120px;
}

.submit-btn-container {
  display: flex;
  justify-content: center;
}

.submit-btn {
  width: 100%;
}

:deep(.captcha-item .el-input-group__append) {
  background: unset;
  border: unset;
}
:deep(.el-form-item__label){
  line-height: 1;
}
:deep(.el-form--label-top .el-form-item__label){
  padding: 0;
}
:deep(.reset-password-form .el-button){
  width: 100%;
  height: 56px;
  font-size: 16px;
}
.success-container{
  padding: 44px 30px 30px 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}
.success-icon{
  font-size: 48px; 
  color: #409eff;
}
.success-title{
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #666;
  margin-top: 9px;
}
:deep(.success-container .el-button){
  width: 182px;
  height: 44px;
  font-size: 14px;
}
.home-btn{
  margin-top: 20px !important;
}
</style>
